<template>
  <v-card :style="{ height: dheight + 'px' }">
    <div class="dashed-border" id="uploading" v-if="file == null">
      <v-file-input
        id="SubmitFile"
        prepend-icon=""
        type="file"
        accept="text/csv"
        clearable
        v-model="file"
        label="Escolha um arquivo"
        variant="solo"
        @change="passValidationEvent"
      ></v-file-input>
      <v-card-text class="upload-container" @click="InputAction()"
        ><v-row
          class="d-flex flex-column"
          dense
          align="center"
          justify="center"
        >
          <font-awesome-icon class="upload-icon" :icon="['fas', 'paperclip']" />
          <p>Arraste um arquivo .CSV até aqui</p>
          <p class="gap-item">ou</p>
          <v-btn class="upload-btn" color="#f0f0f0"
            >Escolha um arquivo local</v-btn
          ></v-row
        ></v-card-text
      >
    </div>

    <div v-if="file != null" id="main_place" style="margin-top: -15px">
      <v-btn
        @click="GoBack()"
        class="exit-button"
        :ripple="true"
        :elevation="false"
        ><font-awesome-icon color="gray" :icon="['fas', 'circle-xmark']"
      /></v-btn>
      <div class="itens d-flex flex-row">
        <svg
          width="39"
          height="55"
          viewBox="0 0 39 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="csv-icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.04839 0.164356C2.2872 0.369316 1.90768 0.577393 1.33877 1.10183C0.757297 1.63786 0.369612 2.27713 0.168948 3.03102C-0.0563159 3.87718 -0.0563159 51.1185 0.168948 51.9647C0.487454 53.1611 1.43352 54.2366 2.5723 54.6967L3.18482 54.9442H19.3518H35.5188L36.1313 54.6967C36.853 54.4051 37.7228 53.6587 38.1091 52.9996C38.713 51.9691 38.6851 52.9427 38.6862 32.8152L38.6873 14.2313L32.5913 7.11563L26.4954 0L15.0549 0.00601563C5.52833 0.010957 3.51976 0.0374902 3.04839 0.164356ZM24.4015 7.06084C24.4019 9.97799 24.4487 12.3754 24.5129 12.7811C24.6603 13.711 25.0716 14.4999 25.7351 15.125C26.3934 15.7453 27.0631 16.0834 27.9065 16.2216C28.2529 16.2783 30.3616 16.325 32.5925 16.3253L36.6487 16.326L36.6208 33.9779L36.593 51.6299L36.3341 52.0077C36.1918 52.2154 35.9053 52.5019 35.6974 52.6442L35.3196 52.9031H19.3596H3.39966L3.01122 52.6403C2.79767 52.4957 2.50763 52.2092 2.36669 52.0036L2.1106 51.6299L2.07912 27.7205C2.05796 11.7075 2.08374 3.68586 2.15711 3.43159C2.28473 2.9888 2.83108 2.39057 3.29224 2.18851C3.55091 2.07507 5.66368 2.04649 14.0076 2.04306L24.4006 2.03887L24.4015 7.06084ZM31.4957 8.91387L36.0323 14.2313L32.2473 14.2595C29.7953 14.2778 28.3111 14.247 28.0332 14.1722C27.4263 14.0088 26.7267 13.281 26.5671 12.6469C26.4813 12.3063 26.4416 10.7132 26.4416 7.60654V3.06421L26.7004 3.3304C26.8428 3.47671 29.0007 5.98931 31.4957 8.91387Z"
            fill="black"
          />
          <path
            d="M9.93066 35.1279C10.3994 35.1279 10.7803 34.999 11.0732 34.7412C11.3662 34.4834 11.5186 34.1406 11.5303 33.7129H13.9121C13.9062 34.3574 13.7305 34.9492 13.3848 35.4883C13.0391 36.0215 12.5645 36.4375 11.9609 36.7363C11.3633 37.0293 10.7012 37.1758 9.97461 37.1758C8.61523 37.1758 7.54297 36.7451 6.75781 35.8838C5.97266 35.0166 5.58008 33.8213 5.58008 32.2979V32.1309C5.58008 30.666 5.96973 29.4971 6.74902 28.624C7.52832 27.751 8.59766 27.3145 9.95703 27.3145C11.1465 27.3145 12.0986 27.6543 12.8135 28.334C13.5342 29.0078 13.9004 29.9072 13.9121 31.0322H11.5303C11.5186 30.54 11.3662 30.1416 11.0732 29.8369C10.7803 29.5264 10.3936 29.3711 9.91309 29.3711C9.32129 29.3711 8.87305 29.5879 8.56836 30.0215C8.26953 30.4492 8.12012 31.1465 8.12012 32.1133V32.377C8.12012 33.3555 8.26953 34.0586 8.56836 34.4863C8.86719 34.9141 9.32129 35.1279 9.93066 35.1279ZM20.5127 34.3721C20.5127 34.0615 20.3574 33.8184 20.0469 33.6426C19.7422 33.4609 19.25 33.2998 18.5703 33.1592C16.3086 32.6846 15.1777 31.7236 15.1777 30.2764C15.1777 29.4326 15.5264 28.7295 16.2236 28.167C16.9268 27.5986 17.8438 27.3145 18.9746 27.3145C20.1816 27.3145 21.1455 27.5986 21.8662 28.167C22.5928 28.7354 22.9561 29.4736 22.9561 30.3818H20.416C20.416 30.0186 20.2988 29.7197 20.0645 29.4854C19.8301 29.2451 19.4639 29.125 18.9658 29.125C18.5381 29.125 18.207 29.2217 17.9727 29.415C17.7383 29.6084 17.6211 29.8545 17.6211 30.1533C17.6211 30.4346 17.7529 30.6631 18.0166 30.8389C18.2861 31.0088 18.7373 31.1582 19.3701 31.2871C20.0029 31.4102 20.5361 31.5508 20.9697 31.709C22.3115 32.2012 22.9824 33.0537 22.9824 34.2666C22.9824 35.1338 22.6104 35.8369 21.8662 36.376C21.1221 36.9092 20.1611 37.1758 18.9834 37.1758C18.1865 37.1758 17.4775 37.0352 16.8564 36.7539C16.2412 36.4668 15.7578 36.0771 15.4062 35.585C15.0547 35.0869 14.8789 34.5508 14.8789 33.9766H17.2871C17.3105 34.4277 17.4775 34.7734 17.7881 35.0137C18.0986 35.2539 18.5146 35.374 19.0361 35.374C19.5225 35.374 19.8887 35.2832 20.1348 35.1016C20.3867 34.9141 20.5127 34.6709 20.5127 34.3721ZM28.1855 33.8975L29.9521 27.4902H32.6064L29.3984 37H26.9727L23.7646 27.4902H26.4189L28.1855 33.8975Z"
            fill="black"
          />
        </svg>
        <div class="d-flex flex-column">
          <p>
            {{ file.name }} -
            <span class="file-size"
              >{{
                (file.size * 10 ** -6).toFixed(2) >= 1
                  ? (file.size * 10 ** -6).toFixed(2) + " MB"
                  : file.size + " Bytes"
              }}
            </span>
          </p>
          <p
            class="file-verification"
            v-if="validation_return == null && !validateExtension()"
          >
            <font-awesome-icon
              color="#0DA6A6"
              class="fa-spin validation-icons"
              :icon="['fas', 'circle-notch']"
            />
            Verificando o arquivo, por favor aguarde...
          </p>
          <p
            class="file-verification-csv-verified"
            v-if="validation_return?.success"
          >
            <font-awesome-icon color :icon="['fas', 'circle-check']" />
            Validado com sucesso
            {{ file?.name }}
          </p>
          <p class="file-verification-csv-error" v-if="validateExtension()">
            <font-awesome-icon
              color="#F7685B"
              class="validation-icons"
              :icon="['fas', 'circle-xmark']"
            />
            Tipo de arquivo não suportado
          </p>
          <p
            class="file-verification-csv-warning"
            v-if="
              !validation_return?.success &&
              validation_return?.error ==
                'Não foi possível encontrar um delimitador para o arquivo'
            "
          >
            <font-awesome-icon
              color="#F7685B"
              class="validation-icons"
              :icon="['fas', 'circle-xmark']"
            />
            Não foi possível encontrar um delimitador para o arquivo
          </p>

          <p
            class="file-verification-csv-warning"
            v-if="
              !validation_return?.success &&
              validation_return?.error ==
                'Falha ao encontrar codificação correta para o arquivo'
            "
          >
            <font-awesome-icon
              color="#F7685B"
              class="validation-icons"
              :icon="['fas', 'circle-xmark']"
            />
            Falha ao encontrar codificação correta para o arquivo
          </p>
          <p
            class="file-verification-csv-warning"
            v-if="
              !validation_return?.success &&
              validation_return?.error == 'Colunas obrigatórias não encontradas'
            "
          >
            <font-awesome-icon
              color="#F7685B"
              class="validation-icons"
              :icon="['fas', 'circle-xmark']"
            />
            Colunas obrigatórias não encontradas
          </p>
        </div>
      </div>
      <div class="divider"></div>

      <p
        v-if="
          !validation_return?.success &&
          validation_return?.error == 'Colunas obrigatórias não encontradas'
        "
        style="
          margin-top: 18px;
          font-family: Roboto;
          font-size: 15px;
          font-weight: 400;
          line-height: 23.13px;
          letter-spacing: 0.025em;
          text-align: left;
        "
      >
        Realize o vínculo de campos manualmente ou tente editar e importar
        novamente seu arquivo.
      </p>

      <header
        v-if="
          !validation_return?.success &&
          validation_return?.error == 'Colunas obrigatórias não encontradas'
        "
        style="
          margin-top: 16px;
          height: 64px;
          border: 1px solid #cccccc;
          background-color: white;
          line-height: 64px;
        "
        class="d-flex flex-row justify-start"
      >
        <p
          style="
            margin-left: 32px;
            font-family: Roboto;
            font-size: 14px;
            font-weight: 400;
          "
        >
          Campo do sistema
        </p>
        <p
          style="
            margin-left: 54px;
            font-family: Roboto;
            font-size: 14px;
            font-weight: 400;
          "
        >
          Tipo
        </p>
        <p
          style="
            margin-left: 85px;
            font-family: Roboto;
            font-size: 14px;
            font-weight: 400;
          "
        >
          Campo importado
          <v-tooltip
            max-width="300px"
            max-height="150px"
            text="	Nibh venenatis curabitur potenti himenaeos egestas massa aliquam sollicitudin, aenean purus venenatis taciti mattis est lacus nisi facilisis, diam potenti donec sagittis nunc feugiat lacinia. sodales pretium vehicula nostra, varius. "
          >
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="white"
                style="
                  margin-left: 11px;
                  margin-bottom: 2px;
                  background-color: #757575;
                  padding: 10px;
                  font-size: 15px;
                  border-radius: 100%;
                "
                icon="mdi-help"
              ></v-icon>
            </template>
          </v-tooltip>
        </p>
      </header>
      <div
        style="height: 250px; overflow-y: auto"
        v-if="
          !validation_return?.success &&
          validation_return?.error == 'Colunas obrigatórias não encontradas'
        "
      >
        <div
          v-for="(item, index) in validation_return?.missing"
          :key="item"
          class="d-flex flex-row"
          style="
            line-height: 64px;
            border-left: 1px solid #cccccc;
            border-right: 1px solid #cccccc;
            border-bottom: 1px solid #cccccc;
          "
        >
          <div style="width: 205px; margin-left: 32px; margin-right: -32px">
            <p
              style="
                font-family: Roboto;
                font-size: 14px;
                font-weight: 400;
                color: #808080;
              "
            >
              {{ item.name }}
            </p>
          </div>

          <div style="width: 112px">
            <p
              style="
                font-family: Roboto;
                font-size: 14px;
                font-weight: 400;
                color: #808080;
              "
            >
              {{ item.type }}
            </p>
          </div>

          <v-autocomplete
            ref="form"
            :loader-height="5"
            :rules="requiredRule"
            class="select-field"
            placeholder="Selecione um campo"
            :items="GetOptions(index)"
            variant="outlined"
            v-model="selected_value[index]"
            @update:model-value="
              updateSelectedValues(item, selected_value[index])
            "
          ></v-autocomplete>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "DataUpload",
  data() {
    return {
      from_to_json: {},
      selected_value: [],
      file: null,
      requiredRule: [(v) => !!v],
    };
  },
  props: {
    validation_return: Array,
    dheight: {
      type: Number,
      default: 352,
    },
  },
  methods: {
    InputAction() {
      let input = document.getElementById("SubmitFile");
      input.click();
    },
    GoBack() {
      this.file = null;
      this.$emit("SetFile", null);
      this.$emit("ChangeCardHeight", false, null, 352);
    },
    passValidationEvent() {
      if (this.validateExtension()) {
        return false;
      }
      this.$emit("SetFile", this.file);
    },
    validateExtension() {
      return (
        this.file &&
        this.file.name &&
        this.file.name.split(".").pop() != "csv"
      );
    },
    updateSelectedValues(item, value) {
      this.selected_value = [...this.selected_value];
      this.from_to_json[value] = item.name;
      this.validateSelections();
    },
    validateSelections() {
      const allFilled = this.validation_return?.missing?.every(
        (item, index) => !!this.selected_value[index]
      );
      if (allFilled) {
        this.$emit("update-validation_return_success", true, this.from_to_json);
      }
    },
  },
  computed: {
    GetOptions() {
      return (index) => {
        const selectedValues = this.selected_value.filter(
          (value, i) => i !== index
        );

        return this.validation_return.unknown.filter(
          (item) => !selectedValues.includes(item)
        );
      };
    },
  },
};
</script>

<style scoped>
.dashed-border {
  border: 2px dashed #a2a2a2;
}

.upload-container {
  position: absolute;
  top: 0;
  margin-top: 50px;
  margin-left: 270px;
}

#SubmitFile {
  height: 175px;
}
.v-card {
  padding: 5px;
  width: 786px;
  height: 350px;
  align-self: center;
  box-shadow: none;
}

.dashed-border .v-input--density-default {
  --v-input-padding-top: 230px;
  opacity: 0;
}

.upload-icon {
  margin-bottom: 14px;
  font-size: 46px;
  color: #d4d4d4 !important;
}

.csv-icon {
  margin-left: 16px;
}

.itens {
  margin-left: 20px;
}

.itens p {
  margin-left: 12px;
  color: #808080;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.upload-btn {
  color: #fff !important;
  text-align: center !important;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 17.807px;
  text-transform: none !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #0da6a6 !important;
}

.exit-button {
  height: 20px;
  min-width: 20px;
  padding: 0;
  font-size: 20px;
  background-color: transparent !important;
  border-radius: 50%;
  margin-bottom: -80px;
  margin-left: -5px;
}

.gap-item {
  margin-bottom: 10px;
}

.file-size {
  color: #808080;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.807px;
}

.divider {
  display: flex;
  height: 1px;
  justify-content: center;
  align-items: center;
  background-color: #d4d4d4;
  margin-top: 25px;
}

.file-verification {
  color: #0da6a6 !important;
  text-align: center;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: italic !important;
  font-weight: 400;
  line-height: 129.2%;
  letter-spacing: 0.35px;
  margin-top: 12px;
  gap: 9px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.file-verification-csv-error,
.file-verification-csv-association {
  color: #f7685b !important;
  text-align: center;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: italic !important;
  font-weight: 400;
  line-height: 129.2%;
  letter-spacing: 0.35px;
  margin-top: 12px;
  display: flex;
  gap: 9px;
  justify-content: flex-start;
  align-items: center;
}

.file-verification-csv-verified {
  color: #23bf6a !important;
  text-align: center;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: italic !important;
  font-weight: 400;
  line-height: 129.2%;
  letter-spacing: 0.35px;
  margin-top: 12px;
  display: flex;
  gap: 9px;
  justify-content: flex-start;
  align-items: center;
}

.file-verification-csv-warning {
  color: #f7685b !important;
  text-align: center;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: italic !important;
  font-weight: 400;
  line-height: 129.2%;
  letter-spacing: 0.35px;
  margin-top: 12px;
  display: flex;
  gap: 9px;
  justify-content: flex-start;
  align-items: center;
}

.select-field {
  max-width: 360px;
  margin-top: 4px;
  margin-bottom: -18px;
  min-height: 40px !important;
}

.validation-icons {
  font-size: 16px;
}

::-webkit-scrollbar {
  width: 8px;
  z-index: 1001;
}
</style>
